import React from 'react';

const Card = ({ children, className = '', variant = 'default' }) => {
  const variants = {
    default: 'bg-secondary-black border-accent-green/20',
    outlined: 'bg-transparent border-accent-green/40',
    elevated: 'bg-secondary-black border-accent-green/30 shadow-xl shadow-accent-green/10'
  };

  return (
    <div className={`
      rounded-2xl border-2
      transition-colors duration-200
      ${variants[variant]}
      ${className}
    `}>
      {children}
    </div>
  );
};

export default Card;